import { LoadableLazy, type LoadableType } from '@confluence/loadable';

export type { PagePdfExportModalProps } from '../src/PagePdfExportModal.tsx';
import type { PagePdfExportModalProps } from '../src/PagePdfExportModal.tsx';

export const PagePdfExportModal: LoadableType<PagePdfExportModalProps> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PagePdfExportModal" */ '../src/PagePdfExportModal.tsx'
			)
		).PagePdfExportModal,
});
